import React, { useState } from 'react'
import Modal from '../../../modal'
import Button from '../../../button'
import styled from 'styled-components'
import { useMutation } from '@apollo/react-hooks'
import LoadingButton from '../../../loading-button'
import RenameDocFile from '../../../../queries/RenameDocFile'
import { useSnackbar } from '../../../../contexts/SnackbarContext'
import TextField from '../../../text-field'

const ButtonsContainerElement = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`

const ContentWrapperElement = styled.form`
  width: 40rem;
  margin: 0 !important;
`

const InputWrapperElement = styled.div`
  margin: 1.5rem 0;
  width: 50%;
`

const separateExtension = (filename) => {
  const words = filename.split('.')
  const extension = words.pop()
  return [words.join('.'), extension]
}

function RenameFileModal({ file, onClose, documentId }) {
  const [originalFilename, extension] = separateExtension(file.trimmedFilename)
  const { setErrorMessage } = useSnackbar()
  const [newFilename, setNewFilename] = useState(originalFilename)

  const [renameDocFileMutation, { loading }] = useMutation(RenameDocFile, {
    variables: {
      input: {
        documentId,
        fileUuid: file.uuid,
        newFileName: `${newFilename}.${extension}`,
      },
    },
    onError: () => setErrorMessage('There was an error renaming the document'),
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    renameDocFileMutation()
  }

  const handleClose = () => !loading && onClose()

  return (
    <Modal title="Rename document" onClose={handleClose}>
      <ContentWrapperElement onSubmit={handleSubmit}>
        <InputWrapperElement>
          <TextField
            value={newFilename}
            onChange={(e) => setNewFilename(e.target.value)}
          />
        </InputWrapperElement>
        <ButtonsContainerElement>
          <Button color="gray" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            disabled={
              !originalFilename || originalFilename === newFilename || loading
            }
            isLoading={loading}
            width="5rem"
            type="submit"
          >
            Update
          </LoadingButton>
        </ButtonsContainerElement>
      </ContentWrapperElement>
    </Modal>
  )
}

export default RenameFileModal
